/**
 * Created by zhouxin on 2017/8/7.
 */
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

// 定义全局状态，VUEX使用
export default new Vuex.Store({
  state: {
    // 用于存储患者基本资料、信息采集页中修改后的信息
    caseName: '',
    case:{
      name: '',
      age: 0,
      gender: ''
    },
    // 用于存储登录医生修改页中需要多组件共享的信息
    login: {
      name: '',
      imgPath: ''
    },
    evalItems:{
      show:true,
      hide:false,
    },
    //当前的机构id
    org:'',
    //count用来控制康复天数的state
    count: 0,
    //selected用来控制快速选择天数高亮显示的state
    selected:-1,
    // 训练次数模块是否打开标识
    showCount: false,
    //剩余训练次数
    trainCounts:'0',
    //rightDay用来控制新建订单时康复天数字段校验文字的展示
    rightDay:false,
    orderStatus: 0,

    //设置训练难度的状态
    hardNum:1,
    //开始训练按钮是否置灰
    startTrain:true,
    //设置训练时长
    startTime:2,
    //游戏训练状态
    gameData:"",
    //认知游戏实际训练时间
    trainsTime:'',
    //控制游戏loading动画的出现
    startGame:false,
    //users/me获取的值
    userMe:"",
    //商品数量
    quantity:"",
  },
  mutations: {
    /* 更改商品数量 */
    changeQuantity(state,num){
      state.quantity = num;
    },
    //控制游戏loading是否展示
    changeGame(state,status){
      state.startGame = status;
    },
    /* 更新游戏实际训练时间 */
    postTrainTime(state,time){
      state.trainsTime = time;
    },
    /* 更新游戏状态 */
    getData(state,game){
      state.gameData = game;
    },
    /* 更新训练时长按钮 */
    changeTime(state,time){
      state.startTime = time;
    },
    /* 更新训练按钮状态 */
    changeStart(state,status){
      state.startTrain = status;
    },
    /* 更新游戏难度 */
    changeHard(state,num){
      state.hardNum = num;
    },

    changeInfo (state,caseName) {
      state.caseName = caseName;
    },
    changeEvalMenu (state,evalItems) {
      state.evalItems.show = true;
      state.evalItems.hide = false;
    },
    changeEval (state,evalItems) {
      state.evalItems.show = false;
      state.evalItems.hide = true;
    },
    clearEval (state,evalItems) {
      state.evalItems.show = false;
      state.evalItems.hide = false;
    },
    getOrgId (state,id) {
      state.org = id;
    },
    //增加康复天数
    add(state){
      state.count++;
    },
    //减少康复天数
    reduce(state){
      state.count <= 0 ?  state.count = 0 : state.count--;
    },
    //自定义康复天数
    getDay(state,days){
      state.count = days;
    },
    //新建订单快速选择康复天数时标签高亮显示
    setSelected(state,index){
      state.selected = index;
    },
    //修改新建订单时康复天数字段校验文字的展示
    changeRightDay(state,status){
      state.rightDay = status;
    },
    //设置剩余训练次数
    changeCounts(state,newCounts=0){
      //查询开始
      Vue.http({
        method: 'GET',
        url:'/api/Users/me',
        params: {

        }
      }).then(function(res){
        Vue.http({
          method: 'GET',
          url:GLOBAL.ORDER+'goods/'+res.data.org_uuid+'/available',
          params: {

          }
        }).then(function(res){
          for(var val in res.data){
            switch(res.data[val].code){
              case 'EM'://判断是否为电子药类型
                state.showCount = !res.data[val].disabled;
                console.log('训练次数开放状态：'+state.showCount)
                state.trainCounts = res.data[val].residue+"";//给训练次数赋值
                break;
              default:
                break;
            }
          }
        });
      });
      //查询结束
    },
    changeOrder(state,status){
      state.orderStatus += status;
    },
    getUsersMe(state,status){
      state.userMe = status;
    },
  },
  actions: {
    changeInfo (context,caseName) {
      context.commit('changeInfo',caseName);
    },
    //设置剩余训练次数（异步）
    getTrainCounts(context,newCounts){
      context.commit('changeCounts',newCounts);
    },
    //新建订单状态获取，用于兄弟组件的刷新
    changeOrder(context,status){
      context.commit('changeOrder',status)
    },
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js